<template>
  <div class="width-main">
    <div class="flexHeader">
        <!-- logo -->
        <div class="logo">
            <img @click="goMatch()" style="width:55px;" :src="'https://static.daoba.com/darkSportsLogo/'+ programId +'.png'" alt="点击选择赛事项目">
            <div class="txt" @click="goMatch()" style="color:black;font-weight:bold;">
                <div class="main">{{program.name}}</div>
                <div class="sub">DAOBA MATCH</div>
                <div :class="IsSwiper?'arrows-down':'arrows-up'"></div>
            </div>
         </div>
        <!-- 菜单名称 -->
        <div class="menu">
            <template v-for="(item, index) in menuList">
            <div
                :key="index"
                @click="switchMenu(item)"
                :class="(item.hover? 'match_hover ' : '') + ' menu-hover'"
            >
                {{ item.title }}
            </div>
            </template>

        </div>
        <div style="position: absolute;top: 20px;right:0;">
          <LoginTag :isEvent="isEvent"/>
        </div>
        
    </div>
    <div class="show-match" v-if="IsSwiper">
        <ProgramSwiper :noShowBg="true" />
    </div>
  </div>
</template>

<script>
import LoginTag from '@comm/components/LoginTag.vue'
import ProgramSwiper from '@daoba-match/views/layout/ProgramSwiper.vue'

export default {
  name: 'headers',
  components: {
    LoginTag,
    ProgramSwiper
  },
  mounted () {
  },
  data () {
    return {
      IsSwiper:false,//显示赛事项目
      programId: Number(this.$route.query.programId),
      program: {},
      isEvent: true,
      menuList: [
        // { title: '咨询', path: '/', hover: false, isRoute: false },
        // { title: '项目介绍', path: '/', hover: false, isRoute: false },
        // { title: '培训', path: '/', hover: false, isRoute: false },
        { title: '首页', path: '/' + this.$route.query.programId, hover: this.$route.name === 'Home', isRoute: true },
        { title: '赛事', path: '/ProgramMatch?programId=' + this.$route.query.programId, hover: this.$route.name === 'ProgramMatch', isRoute: true },
        { title: '运动员', path: '/ProgramRank?programId=' + this.$route.query.programId, hover: this.$route.name === 'ProgramRank', isRoute: true },
        { title: '机构', path: '/ProgramAgency?programId=' + this.$route.query.programId, hover: this.$route.name === 'ProgramAgency', isRoute: true },
        { title: '活动', path: '/ActivityIndex?programId=' + this.$route.query.programId, hover: this.$route.name === 'ActivityIndex', isRoute: true }
      ]
    }
  },
  created () {
    this.getAllProgram()
  },
  methods: {
    goMatch () {
    //   this.$router.push('/ProgramMatch?programId=' + this.$route.query.programId)
      this.IsSwiper=!this.IsSwiper
    },
    switchMenu (item) {
      if (item.isRoute) {
        if (this.$route.fullPath !== item.path) {
          this.$router.push(item.path)
        }
      } else {
        this.$message.info('正在开发中')
      }
    },
    getAllProgram () {
      this.$api.match.getAllProgram().then(res => {
        if (res.status === 0) {
          let all = res.data
          all.forEach(item => {
            if (item.id == this.programId) {
              this.program = item
            }
          })
          this.program.englishName = this.program.englishName.toUpperCase()
          // console.log('res', this.program)
        }
      }).catch(err => {
        console.log(err)
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.width-main {
  position: relative;
  .flexHeader {
        display: flex;
        z-index: 20;
        margin-top: 10px;
        position: relative;
        width: 1200px;
        margin: 0 auto;
        .logo {
            color: #fff;
            cursor: pointer;
            display: flex;
            position: relative;
            flex-direction: row;
            align-items: center;
            justify-content: flex-start;
            width: 160px;
            margin-right: 20px;
            .arrows-down{
                position: absolute;
                width: 0;
                height: 0;
                right: -15px;
                top:50%;
                transform: translateY(-2px);
                border: 5px solid #000;
                border-bottom-color: transparent;
                border-right-color: transparent;
                border-left-color: transparent;
            }
            .arrows-up{
                position: absolute;
                width: 0;
                height: 0;
                right: -15px;
                top:50%;
                transform: translateY(-10px);
                border: 5px solid #000;
                border-top-color: transparent;
                border-right-color: transparent;
                border-left-color: transparent;
            }
        }
    .menu {
        display: flex;
        div {
        margin: 0 10px;
        padding: 18px 20px;
        cursor: pointer;
        font-size: 15px;
        text-align: center;
        font-weight: bold;
        color: rgb(29, 29, 29);
        border-bottom: 2px solid #fff;
        }
        .menu-hover:hover{
        //   border-bottom: 2px solid #b01f23;
        color: #b01f23;
        }
    }
    .ant-dropdown-link {
        color: #fff;
        }
    }
    .match_hover{
        color: #b01f23 !important;
    } 

    .show-match{
        width: 100%;
        position: absolute;
        top: 120px;
        left: 0;
        z-index: 9999;
    }
}



</style>



// WEBPACK FOOTER //
// src/daoba-match/views/program/components/Header.vue